import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import awsmobile from './aws-exports.js';
import { Authenticator } from '@aws-amplify/ui-react';
import { withAuthenticator } from '@aws-amplify/ui-react';

import LandingPage from './components/LandingPage';
import Quiz from './components/Quiz';
import LoginPage from './components/LoginPage';
import TestsPage from './components/TestsPage';
import TestExecutionsPage from './components/TestExecutionsPage';

import "./App.css";

import {
  View, Flex, Text, Heading, TextField, Button,
} from "@aws-amplify/ui-react";

import '@aws-amplify/ui-react/styles.css';
import {TestExecution} from "./models";
import ArithmeticPractice from './components/ArithmeticPractice';




Amplify.configure(awsmobile);

// Amplify.configure({
//   Auth: {
//     Cognito: {
//       //  Amazon Cognito User Pool ID
//       userPoolId: 'us-east-1_xa062Nw5x',
//       // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
//       userPoolClientId: '1opst28r2d3rqegcdqbsrrvl6q',
//       // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
//       // identityPoolId: 'XX-XXXX-X:XXXXXXXX-XXXX-1234-abcd-1234567890ab',
//       // OPTIONAL - Set to true to use your identity pool's unauthenticated role when user is not logged in
//       allowGuestAccess: true,
//       // OPTIONAL - This is used when autoSignIn is enabled for Auth.signUp
//       // 'code' is used for Auth.confirmSignUp, 'link' is used for email link verification
//       signUpVerificationMethod: 'code', // 'code' | 'link'
//       loginWith: {
//         // OPTIONAL - Hosted UI configuration
//         oauth: {
//           domain: 'https://mathrxw.auth.us-east-1.amazoncognito.com',
//           scopes: [
//             'phone',
//             'email',
//             'profile',
//             'openid',
//             'aws.cognito.signin.user.admin'
//           ],
//           redirectSignIn: ['http://localhost:3000/'],
//           redirectSignOut: ['http://localhost:3000/'],
//           responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
//         }
//       }
//     }
//   }
// });

// function App() {
//   return (
//     <Router>
//       <div className="App">
//         <Routes>
//           <Route path="/" element={<LandingPage />} />
//
//           {/*<Route path="/quiz" element={<Quiz />} />*/}
//           {/*<Route path="/login" element={<LoginPage />} />*/}
//           {/*<Route path="/tests" element={<TestsPage />} />*/}
//           {/*<Route path="/practices" element={<TestExecutionsPage />} />*/}
//         </Routes>
//       </div>
//     </Router>
//   );
// }

const App = () => (
    <Authenticator.Provider>

        <Router>
            <Routes>
                <Route path="/arithmeticpractice" element={<ArithmeticPractice />} />
                <Route path="/" element={<LandingPage />} />
            </Routes>
        </Router>
    </Authenticator.Provider>
);

export default App;
